import Vue from 'vue';
import axios from 'axios';
import i18n from '@/i18n';

export default {
  baseURL: process.env.BASE_URL + 'api/vwtap',

  getSurveyInstanceData(filter) {
    return axios.get('survey-instance-data',{ 
      baseURL: this.baseURL,
      params: {
        'survey-id': filter?.survey?.Survey?.SurveyId,
        'wave-ids': (filter && _.size(filter.wave) > 0) ? filter.wave.join() : null,
        'scenario-ids': (filter && _.size(filter.scenario) > 0) ? filter.scenario.join() : null,
        'custompropertyvalue-ids': (filter && _.size(filter.customProp) > 0) ? filter.customProp.join() : null,
        'surveyinstance-status-id-minimum': filter.statusFrom,
        'surveyinstance-status-id-maximum': filter.statusTo,
        'localization-id': i18n.locale,
        'premium-to-volumen': filter.premiumToVolumen ? filter.premiumToVolumen : null,
      }
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return Promise.reject(error);
    });
  },
  getGridColumnDefinitions(level) {
    return axios.get('grid-column-definitions',{ 
      baseURL: this.baseURL,
      params: {
        'level': level,
        'localization-id': i18n.locale,
      }
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return Promise.reject(error);
    });
  },
  setIncludeRegardlessOfValues(surveyInstanceId, includeRegardlessOfValues) {
    return axios.get('set-include-regardless-of-values',{ 
      baseURL: this.baseURL,
      params: {
        'survey-instance-id': surveyInstanceId,
        'include-regardless-of-values': includeRegardlessOfValues,
      }
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return Promise.reject(error);
    });
  },
  getReport(filter) {
    return axios.get('get-report',{ 
      baseURL: this.baseURL,
      responseType: 'blob',
      params: {
        'survey-id': filter?.survey?.Survey?.SurveyId,
        'wave-ids': (filter && _.size(filter.wave) > 0) ? filter.wave.join() : null,
        'scenario-ids': (filter && _.size(filter.scenario) > 0) ? filter.scenario.join() : null,
        'custompropertyvalue-ids': (filter && _.size(filter.customProp) > 0) ? filter.customProp.join() : null,
        'surveyinstance-status-id-minimum': filter.statusFrom ? filter.statusFrom : null,
        'surveyinstance-status-id-maximum': filter.statusTo ? filter.statusTo : null,
        'get-net': filter.getNet ? filter.getNet : false,
        'localization-id': i18n.locale,
        'report-type': filter.reportType,
        'premium-to-volumen': filter.premiumToVolumen ? filter.premiumToVolumen : null,
      }
    })
    .catch(function (error) {
      console.log(error);
      return Promise.reject(error);
    });
  },
  getFsReport(filter) {
    return axios.get('get-fs-report',{ 
      baseURL: this.baseURL,
      responseType: 'blob',
      params: {
        'survey-id': filter?.survey?.Survey?.SurveyId,
        'wave-ids': (filter && _.size(filter.wave) > 0) ? filter.wave.join() : null,
        'scenario-ids': (filter && _.size(filter.scenario) > 0) ? filter.scenario.join() : null,
        'custompropertyvalue-ids': (filter && _.size(filter.customProp) > 0) ? filter.customProp.join() : null,
        'surveyinstance-status-id-minimum': filter.statusFrom ? filter.statusFrom : null,
        'surveyinstance-status-id-maximum': filter.statusTo ? filter.statusTo : null,
        'get-net': filter.getNet ? filter.getNet : false,
        'localization-id': i18n.locale,
        'report-type': filter.reportType != null ? filter.reportType : null,
        'premium-to-volumen': filter.premiumToVolumen ? filter.premiumToVolumen : null,
      }
    })
    .catch(function (error) {
      console.log(error);
      return Promise.reject(error);
    });
  },
  getRawData(filter) {
    return axios.get('get-raw-data',{ 
      baseURL: this.baseURL,
      responseType: 'blob',
      params: {
        'survey-id': filter?.survey?.Survey?.SurveyId,
        'wave-ids': (filter && _.size(filter.wave) > 0) ? filter.wave.join() : null,
        'scenario-ids': (filter && _.size(filter.scenario) > 0) ? filter.scenario.join() : null,
        'custompropertyvalue-ids': (filter && _.size(filter.customProp) > 0) ? filter.customProp.join() : null,
        'surveyinstance-status-id-minimum': filter.statusFrom ? filter.statusFrom : null,
        'surveyinstance-status-id-maximum': filter.statusTo ? filter.statusTo : null,
        'get-net': filter.getNet ? filter.getNet : false,
        'localization-id': i18n.locale,
        'report-type': filter.reportType != null ? filter.reportType : null,
        'premium-to-volumen': filter.premiumToVolumen ? filter.premiumToVolumen : null,
      }
    })
    .catch(function (error) {
      console.log(error);
      return Promise.reject(error);
    });
  }
}